import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auto-closed-button',
  templateUrl: './auto-closed-button.component.html',
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class AutoClosedButtonComponent implements OnInit {
  @Input() text!: string;
  @Input() delayInSeconds!: number;
  @Input() closeCallback!: () => void;

  ngOnInit(): void {
    setTimeout(() => {
      this.closeCallback();
    }, this.delayInSeconds * 1000);
  }
}
